import { createSlice } from '@reduxjs/toolkit';

const favoritesFromStorage = localStorage.getItem("favorites");
const initialState = {
  items: favoritesFromStorage ? JSON.parse(favoritesFromStorage) : []
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    addFavorite: (state, action) => {
      const exists = state.items.find(item => item.id === action.payload.id);
      if (!exists) {
        state.items.push(action.payload);
      }
    },
    removeFavorite: (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    setFavorites: (state, action) => {
      state.items = action.payload;
    }
  }
});

export const { addFavorite, removeFavorite, setFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer;